<div class="modal-header">
  <h1 translate>EDIT_ORDER_ROW</h1>
</div>
<div class="modal-body">
  <div class="col-12">
    <div class="row">
      <span translate>ORDER_EDIT_TERMS</span>
    </div>
    <div class="row">
      <lib-delivery-date-picker-beta
        class="request-delivery-date"
        [label]="null"
        [initialDate]="minInitialDate"
        [minInitialDate]="minInitialDate"
        (selectedDate)="updateDeliveryDate(data, $event)"
        [currentselectedDate]="data.extra.orp.ordberlevdat"
        [deliveryMethod]="data.extra.orp.levsattkod"
      >
      </lib-delivery-date-picker-beta>
    </div>
    <div class="row" style="margin-top: 0.5rem">
      <input type="checkbox" id="applyOnOrder" name="applyOnOrder" [(ngModel)]="applyOnOrder" />
      <label style="margin-left: 0.5rem" for="applyOnOrder" translate>APPLY_ON_WHOLE_ORDER</label>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-dark" (click)="onCancel()" translate>CANCEL</button>
  <button type="button" class="btn btn-outline-dark" (click)="onSave()" translate>SAVE</button>
</div>
